import { useMemo } from 'preact/hooks';

const DEFAULT_PLACEHOLDERS_COUNT = 10;

export const usePlaceholders = (
  isFetched: boolean,
  count: number = DEFAULT_PLACEHOLDERS_COUNT
) => {
  const placeholders = useMemo(() => {
    if (isFetched) {
      return [];
    }

    return [...Array(count)].map((_, index) => index);
  }, [isFetched, count]);

  return { placeholders };
};
